import * as React from 'react';
import { History } from 'history';
import Model from './report-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  parentId?: number; //report parent id
  previewId?: number; //related data id (such as: transactionid, eventid)
  reportgroupId?: number;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
  onLoadAll?: (data: any) => void;
}

interface IState {
}

export default class ReportList extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
  }

  private onLoadAll = (data: any) => {
    if (this.props.onLoadAll) {
    } 
  }

  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.parentId || this.props.previewId} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.parentId, this.props.reportgroupId)} url={(this.props.root || '') + Model.url} model={Model} actions={this.props.actions} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
